import { Getter, State, Action, Mutation } from 'vuex-class'
import { Component, Prop, Watch } from 'vue-property-decorator'
import Vue from 'vue'

import Footer from '@/components/footer/footer'
import commerceBanner from '@/components/commerceBanner/commerceBanner'
import category from '@/components/commerceCategory/commerceCategory'
import SkeletonList from '@/components/skeletonList/skeletonList'
import SkeletonFluid from '@/components/skeletonFluid/skeletonFluid'
import ProductsBtn from '@/components/productsBtn/productsBtn'
import Alert from '@/components/alert/alert'
import store from '../../store/store'
import SuperCategoriesScrollMenu from '@/components/superCategoriesScrollMenu/superCategoriesScrollMenu'
import SuperCategories from '@/components/superCategories/superCategories'
import { cityParser } from '@/plugins/city_parser'
import ProductsCarousel from '@/components/productsCarousel/productsCarousel'
import SuperCategoriesNavigator from '@/components/superCategoriesNavigator/superCategoriesNavigator'


@Component({
  components: {
    Footer,
    category,
    commerceBanner,
    SkeletonList,
    SkeletonFluid,
    ProductsBtn,
    SuperCategories,
    Alert,
    SuperCategoriesScrollMenu,
    ProductsCarousel,
    SuperCategoriesNavigator
  }
})
export default class CommerceProducts extends Vue {

  @Action action_getCategories: any
  @Getter getCartTemporal: any
  @Getter getCategories: any
  @Getter getIsUnderMobile: any
  @Getter getCurrentSuperCategory: any
  @Getter getIsLoadingCategories: any
  @Getter getCity;

  @Mutation CART_TEMPORAL: any
  @Mutation IS_SELECT_COUNTRY
  @Mutation CURRENT_CATEGORY
  @Mutation CURRENT_PRODUCT
  @Mutation CURRENT_SUPER_CATEGORY;

  /* Supercategoríes */
  superCategoryId       = 1
  superCategorySelected = {}

  /* Categoríes */
  categories            = []
  categoryIndex         = 0

  /* Show and modals*/
  close = ''
  isShowCartClear = false
  toggleCar = false
  loading = false

  get getSuperCategories() {
    let response = [];
    if (this.getCity && this.getCity.super_categories && this.getCity.super_categories.length) {
      response = this.getCity.super_categories.filter(
        (superCategory) => superCategory.is_active === true
      );
    }
    return response;
  }

  async mounted() {
    this.loading = true;   
    this.CURRENT_CATEGORY(null);
    this.CURRENT_PRODUCT(null);
    await store.dispatch('action_getCity', 3);
    await this.setCurrentSuperCategory();
    this.loading = false;
    document.getElementById('main').scrollTop = 0;
  }

  sortByOrdinal(a, b) {
    if(a && a.ordinal && b && b.ordinal) {
      if(a.ordinal > b.ordinal) {
        return 1;
      }
      if(a.ordinal < b.ordinal) {
        return -1;
      }
      return 0;
    }
  }

  async setCurrentSuperCategory() {
    try {
      if(this.$route && this.$route.query && this.$route.query.pasillo) {
        const pasillo = this.$route.query.pasillo;
        if(pasillo.length) {
          const search = this.getSuperCategoryByName(cityParser(pasillo));
          if(search && search.id) {
            this.CURRENT_SUPER_CATEGORY(search);
            await this.action_getCategories(search.id);
          } else {
            await this.setDefaultSuperCategory();
          }
        }
      } else {
        await this.setDefaultSuperCategory();
      }
    } catch (error) {
      this.$swal({
        title: 'Error',
        text: '¡Ups! Hubo un error de nuestra parte. Por favor, intenta de nuevo'
      });
    }
  }

  @Watch('getCurrentSuperCategory')
  async onCurrentSuperCategoryChange() {
    this.loading = true;
    await this.action_getCategories(this.getCurrentSuperCategory.id);
    this.loading = false;
  }

  async setDefaultSuperCategory() {
    if (
      this.getCity &&
      this.getSuperCategories &&
      this.getSuperCategories.length &&
      this.getSuperCategories[0] &&
      this.getSuperCategories[0].id
    ) {
      this.CURRENT_SUPER_CATEGORY(this.getSuperCategories[0]);
      try {
        this.$router.replace({ query: {
          pasillo: cityParser(this.getCurrentSuperCategory.name)
        }});
      } catch (error) {
        // Do Nothing!
      }
    }
  }

  getSuperCategoryByName(name) {
    let response = null;
    const superCategories = this.getCity.super_categories;
    if (name && name.length) {
      response = superCategories.find(
        (superCategory) =>
          cityParser((superCategory.name as string).toLowerCase()) ===
          cityParser((name as string).toLowerCase())
      );
    }
    return response;
  }

  routeCategory(category) {
    if(category && category.name && category.id) {
      this.CURRENT_CATEGORY(category);
      this.$router.push({ name: 'commerceCategory', params: {
        category_id: category.id 
      }});
    }
  }

  _setCategory(value, index) {
    this.categoryIndex = index
    document.querySelector(`#category_${value.id}`).scrollIntoView({
      behavior: 'smooth'
    });
  }

  /* Modals */
   _toggleCartClear() {
    this.isShowCartClear = !this.isShowCartClear
  }

}
